import React from "react";

export default function Faq() {
  return <h1>FAQ Page</h1>;
}
